enum Permissions {
  ReadPatients = 'read:patients',
  WritePatients = 'write:patients',

  ReadAppointments = 'read:appointments',
  WriteAppointments = 'write:appointments',

  ReadAllergy = 'read:allergy',
  WriteAllergy = 'write:allergy',

  ReadMedication = 'read:medication',
  WriteMedication = 'write:medication',

  ReadDiagnosis = 'read:diagnosis',
  WriteDiagnosis = 'write:diagnosis',

  RequestLab = 'write:labs',
  CancelLab = 'cancel:lab',
  CompleteLab = 'complete:lab',
  ViewLab = 'read:lab',
  ViewLabs = 'read:labs',

  ReadSettings = 'read:settings',
  WriteSettings = 'write:settings',

  ReadClinics = 'read:clinics',
  WriteClinics = 'write:clinis',
  addClinics = 'add:clinics',

  ReadNotes = 'read:notes',
  WriteNotes = 'write:notes',

  ReadNutrition = 'read:nutrition',
  WriteNutrition = 'write:nutrition',

  ReadPhysicalActivity = 'read:physicalActivity',
  WritePhysicalActivity = 'write:physicalActivity',

  ReadReferral = 'read:referral',
  WriteReferral = 'write:referral',

  ReadPatientAppointmentTab = 'read:PatientAppointmentTab',
  WritePatientAppointmentTab = 'write:PatientAppointmentTab',

  ReadPatientDashboardTab = 'read:PatientDashboardTab',
  WritePatientDashboardTab = 'write:PatientDashboardTab',

  ReadPatientMedicalFileTab = 'read:PatientMedicalFileTab',
  WritePatientMedicalFileTab = 'write:PatientMedicalFileTab',

  ReadExaminationsList = 'read:ExaminationsList',
  WriteExaminationsList = 'write:ExaminationsList',

  ReadLabTestsList = 'read:LabTestsList',
  WriteLabTestsList = 'write:LabTestsList',

  ReadMonitoring = 'read:Monitoring',
  WriteMonitoring = 'write:Monitoring',

  // Device incident log (equipment outages). NOTE: like every entry here, these gate the UI only —
  // ehr-server has no server-side permission system, so its routes assert session.admin directly.
  ReadDeviceIncidents = 'read:deviceIncidents',
  WriteDeviceIncidents = 'write:deviceIncidents',

  assignOwner = 'write:Owner',

  WriteprintBraclet = 'write:printBraclet',

  AdminPermissions = 'admin:adminPermissions',
}

export default Permissions
